import { SessionType } from "@prisma/postgresClient";

export default SessionType;
